// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.retiree-portal-toggle {
  display: block;
  width: 100%;
}
.retiree-portal-toggle .toggle-control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.retiree-portal-toggle .toggle-control .custom-switch {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding-left: 0 !important;
}
.retiree-portal-toggle .toggle-control .custom-switch .form-check-input {
  width: 2.5rem;
  height: 1.25rem;
  background-color: #6c757d;
  border-color: #6c757d;
  margin: 0 !important;
  float: none !important;
}
.retiree-portal-toggle .toggle-control .custom-switch .form-check-input:checked {
  background-color: #8f003c;
  border-color: #8f003c;
}
.retiree-portal-toggle .toggle-control .custom-switch .form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(143, 0, 60, 0.25);
  border-color: #8f003c;
}
.retiree-portal-toggle .toggle-control .custom-switch .form-check-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.retiree-portal-toggle .toggle-control .custom-switch .form-check-label {
  font-weight: 500;
  color: #495057;
  margin-left: 0.5rem;
  font-size: 0.85rem;
  line-height: 1.25rem;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .retiree-portal-toggle .toggle-control .custom-switch .form-check-label {
    font-size: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RetireePortalToggle/RetireePortalToggle.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AAAN;AAEM;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;AAAR;AAEQ;EACE,yBAAA;EACA,qBAAA;AAAV;AAGQ;EACE,gDAAA;EACA,qBAAA;AADV;AAIQ;EACE,YAAA;EACA,mBAAA;AAFV;AAMM;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAJR;AAUE;EAGM;IACE,kBAAA;EAVR;AACF","sourcesContent":[".retiree-portal-toggle {\n  display: block;\n  width: 100%;\n  // text-align: center;\n\n  .toggle-control {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    .custom-switch {\n      display: inline-flex;\n      align-items: center;\n      margin: 0;\n      padding-left: 0 !important;\n\n      .form-check-input {\n        width: 2.5rem;\n        height: 1.25rem;\n        background-color: #6c757d;\n        border-color: #6c757d;\n        margin: 0 !important;\n        float: none !important;\n\n        &:checked {\n          background-color: #8f003c;\n          border-color: #8f003c;\n        }\n\n        &:focus {\n          box-shadow: 0 0 0 0.25rem rgba(143, 0, 60, 0.25);\n          border-color: #8f003c;\n        }\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: not-allowed;\n        }\n      }\n\n      .form-check-label {\n        font-weight: 500;\n        color: #495057;\n        margin-left: 0.5rem;\n        font-size: 0.85rem;\n        line-height: 1.25rem;\n        display: inline-block;\n        vertical-align: middle;\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  // Responsive design\n  @media (max-width: 768px) {\n    .toggle-control {\n      .custom-switch {\n        .form-check-label {\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
